export default __webpack_public_path__ + "static/media/loading.a998f1b7.gif";